import { useEffect, useState } from 'react';
import {
  getFlashsalesDesktopFooterHeight,
  getFlashsalesDesktopMenuHeight,
} from '@secretescapes/cauldron';
import { debounce } from '@utils/lodash.utils';

export const useFlashsalesHeights = () => {
  const [headerHeight, setHeaderHeight] = useState(0);
  const [footerHeight, setFooterHeight] = useState(0);

  const menuHeight = useObserveMenuHeight();

  useEffect(() => {
    setHeaderHeight(menuHeight);
    setFooterHeight(getFlashsalesDesktopFooterHeight());
  }, [menuHeight]);

  return {
    headerHeight,
    footerHeight,
  };
};

/**
 * A hook that return "menu" height whenever there is update of its height
 *
 * NOTE: A temporary workaround to integrate with new navigation.
 */
export function useObserveMenuHeight() {
  const [height, setHeight] = useState(getFlashsalesDesktopMenuHeight());

  useEffect(() => {
    const menuEle =
      document.getElementById('menu') ?? document.getElementById('cauldronHeaderAnchor');
    if (!menuEle || !('ResizeObserver' in window)) {
      return;
    }

    const debounceSetHeight = debounce(() => setHeight(menuEle.offsetHeight), 100);
    const observer = new ResizeObserver(debounceSetHeight);

    observer.observe(menuEle, { box: 'border-box' });

    return () => {
      observer.disconnect();
    };
  }, []);

  return height;
}
